import { cn } from '@/lib/cn';
import type { JSX } from 'solid-js';

export interface SkeletonProps {
  class?: string;
  height?: string;
  width?: string;
}

export const Skeleton = (props: SkeletonProps): JSX.Element => (
  <div
    class={cn('animate-pulse rounded-lg bg-neutral-200 dark:bg-neutral-800', props.class)}
    style={{
      ...(props.height ? { height: props.height } : {}),
      ...(props.width ? { width: props.width } : {}),
    }}
  />
);
